import styles from './AccordionComponent.module.scss';
import { Icon } from "../Icon";
import { ReactNode, useState } from 'react';
import clsx from 'clsx';



type AccordionComponentT = {
  label: string;
  children: ReactNode;
  className?: string;
  aid?: number;
  parent?: string;
}

export const AccordionComponent = ({ label, children, className, aid, parent }: AccordionComponentT) => {

  const initStateString = localStorage.getItem(`accordion_${parent}`);
  const initStateJson = typeof initStateString === 'string' ? JSON.parse(initStateString) : {};

  const [isOpen, setIsOpen] = useState<boolean>(initStateJson['aid_' + aid]);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
    const initStateString = localStorage.getItem(`accordion_${parent}`);
    const initStateJson = typeof initStateString === 'string' ? JSON.parse(initStateString) : {};
    const useJson = { ...initStateJson, ['aid_' + aid]: !isOpen };
    localStorage.setItem(`accordion_${parent}`, JSON.stringify(useJson));
  }

  return (
    <div className={styles.root} data-aid={aid}>
      <div className={styles.header} onClick={toggleAccordion}>
        <div className={styles.icon} data-open={isOpen}>
          <Icon name="chevron-down-small" size="14px" />
        </div>
        <div className={styles.label}>{label}</div>
        <div className={styles.line} />
      </div>
      <div className={clsx(styles.children, className)} data-open={isOpen}>{children}</div>
    </div>
  )


}